module.exports = __webpack_public_path__ + "static/media/media3.394a8487.png";